import React, { Component } from 'react';
import { Field, reduxForm, getFormInitialValues, initialize, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Select from 'components/forms/Select';
import PropTypes from 'prop-types';
import Button from 'components/buttons/Button';
import LoadingIcon from 'mdi-react/LoadingIcon';

import RenderFormInput from 'components/forms/RenderFormInput';
import ScheduleModal from 'components/modals/ScheduleModal';
import withModal from 'components/modals/withModal';
import { getSchedules } from 'redux/actions/scheduleActions';
import { resultsToOptions } from 'utils/misc';
import RenderDateTimePicker from 'components/forms/RenderDateTimePicker';
import { requiredValidator, handleBlur } from 'utils/validators';
import RenderSwitchInput from 'components/forms/RenderSwitchInput';
import ScheduleBtn from '../../ScheduleModal/ScheduleBtn';


class SequenceDetailsForm extends Component {
  async componentDidMount() {
    const { sequence, hasSchedules } = this.props;
    if (!sequence.id && !hasSchedules) {
      // loading schedules
      await this.props.getSchedules({ account__id: this.props.campaign.account });
      const primary = this.props.schedules.results.filter(schedule => schedule.is_primary);
      let initialValues = {
        validate_contacts: true,
        send_to_risky: false,
      };
      if (primary.length > 0) {
        // if campaign has primary schedule then it will be set as default
        initialValues = {
          ...initialValues,
          schedule: resultsToOptions(primary, 'name')[0],
        };
      } else {
        // setting Default schedule as selected
        initialValues = {
          ...initialValues,
          schedule: resultsToOptions(this.props.schedules.results, 'name')[0],
        };
      }
      this.props.dispatch(initialize(
        'sequenceCreateBasicForm',
        initialValues,
      ));
    }
  }

  render() {
    const {
      handleSubmit,
      schedules,
      submitting,
      toggleModal,
      pristine,
      submitBtnText,
      formValues,
      sequence,
    } = this.props;

    let timezone = null;
    const { loading } = schedules;
    const isLoading = loading || sequence.loading || submitting;
    if (formValues && formValues.schedule) {
      let { schedule } = formValues;
      schedule = schedules.results.find(sch => sch.id === schedule.value);
      timezone = schedule ? schedule.timezone : null;
    }

    return (
      <React.Fragment>
        <form className="instance-form mt-2" onSubmit={handleSubmit}>
          {isLoading && <div className="loader"><LoadingIcon /></div>}
          <div className="instance-form__body">

            {/* eslint-disable jsx-a11y/label-has-for */}
            <label>Sequence name</label>
            <Field
              maxLength="255"
              name="name"
              component={RenderFormInput}
              type="text"
              onBlur={handleBlur}
              validate={[requiredValidator]}
            />

            {/* eslint-disable jsx-a11y/label-has-for */}
            <label>Schedule</label>
            <div className="schedule-create">
              <Field
                name="schedule"
                component={propsCus => (
                  <Select
                    value={propsCus.input.value}
                    onChange={propsCus.input.onChange}
                    onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
                    options={resultsToOptions(schedules.results, 'name') || []}
                  />
                )}
              />
              <ScheduleBtn className="icon__edit" toggle={this.props.toggle} />
            </div>

            {/* eslint-disable jsx-a11y/label-has-for */}
            <label>Launch date</label>
            <Field
              name="launch_date"
              className="date-picker"
              validate={[requiredValidator]}
              component={RenderDateTimePicker}
              withPortal
              timezone={timezone}
              minDate={new Date()}
            />

            {submitBtnText === 'Update' &&
              <>
                <div>
                  {/* eslint-disable jsx-a11y/label-has-for */}
                  <label htmlFor="validate_contacts">
                    Validate contacts
                    {/* eslint-enable jsx-a11y/label-has-for */}
                    <Field
                      maxLength="255"
                      id="validate_contacts"
                      name="validate_contacts"
                      component={RenderSwitchInput}
                    />
                  </label>
                </div>

                {formValues && formValues.validate_contacts &&
                  <div>
                    {/* eslint-disable jsx-a11y/label-has-for */}
                    <label className="mt-0" htmlFor="send_to_risky">
                      Send to risky emails
                      {/* eslint-enable jsx-a11y/label-has-for */}
                      <Field
                        maxLength="255"
                        id="send_to_risky"
                        name="send_to_risky"
                        component={RenderSwitchInput}
                      />
                    </label>
                  </div>
                }
              </>
            }
          </div>
          <div className="instance-form__footer">
            {toggleModal && (
              <Button
                color="secondary"
                variant="text"
                onClick={toggleModal}
              >
                Cancel
              </Button>
            )}
            <Button
              color="primary"
              variant="contained"
              disabled={pristine || submitting}
              type="submit"
              className="ml-2"
            >
              {submitBtnText}
            </Button>
          </div>
        </form>
        <ScheduleModal isOpen={this.props.isOpen} toggle={this.props.toggle} />
      </React.Fragment>
    );
  }
}

SequenceDetailsForm.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  getSchedules: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  submitBtnText: PropTypes.string,
  sequence: PropTypes.shape({
    launch_date_time_zone: PropTypes.string.isRequired,
  }).isRequired,
  schedules: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    results: PropTypes.array,
  }).isRequired,
  campaign: PropTypes.shape({
    id: PropTypes.number,
    account: PropTypes.number,
    name: PropTypes.string,
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
  }).isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    validate_contacts: PropTypes.bool,
    send_to_risky: PropTypes.bool,
    launch_date: PropTypes.instanceOf(Date),
    schedule: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  }),
  hasSchedules: PropTypes.bool,
  formValues: PropTypes.shape({
    schedule: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

SequenceDetailsForm.defaultProps = {
  submitBtnText: 'Next',
  // isExternalEdit: false,
  submitting: false,
  pristine: true,
  initialValues: {},
  hasSchedules: false,
};

export default compose(
  connect(
    state => ({
      initialValues: getFormInitialValues('sequenceCreateBasicForm')(state),
      formValues: getFormValues('sequenceCreateBasicForm')(state),
      campaign: state.campaign,
      schedules: state.schedules,
      sequence: state.sequence,
    }),
    { getSchedules },
  ),
  reduxForm({
    form: 'sequenceCreateBasicForm',
    // will allow us to preserve form values in the initialValues
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
)(withModal(SequenceDetailsForm));
